module.exports = __webpack_public_path__ + "static/media/cooperation-tie.1cb05541.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/cooperation-tie.svg
// module id = 207
// module chunks = 6